import { ComponentType } from "react";
import { Tab } from "@headlessui/react";
import clsx from "clsx";

import styles from "./Tabs.module.css";

type ExtractProps<T> = T extends ComponentType<infer P> ? P : T;

export type TabPanelProps = ExtractProps<(typeof Tab)["Panel"]>;

export const TabPanel: React.FC<TabPanelProps> = ({ className, children, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Tab.Panel {...props} className={clsx(styles.tabPanel, className)}>
    {children}
  </Tab.Panel>
);
